var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import * as React from 'react';
import { classNames } from '@shapeable/utils';
var cls = classNames('page-renderer');
import styled, { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme';
import { kebabCase, keys } from 'lodash';
import { usePageLayouts } from '../hooks/use-page-layouts';
import { useDefaultPageLayout } from '../hooks/use-default-page-layout';
import { SlicesRenderer } from './slices-renderer';
export var PageRendererDefaultProps = {
  useSlices: true
};
// -------- Components -------->
var BodyStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var My = {
  Body: styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles)
};
export var PageRenderer = function (props) {
  var entity = props.entity,
    useSlices = props.useSlices,
    className = props.className;
  var pageLayouts = usePageLayouts();
  var DefaultLayout = useDefaultPageLayout() || function () {
    return React.createElement(React.Fragment, null);
  };
  if (!entity) {
    // amend to page not found?
    return React.createElement("div", null);
  }
  var _a = entity.slices,
    slices = _a === void 0 ? [] : _a,
    layout = entity.layout,
    _b = entity.embeds,
    embeds = _b === void 0 ? {} : _b;
  var Layout = layout ? pageLayouts[layout.component] || DefaultLayout : DefaultLayout;
  if (layout && !pageLayouts[layout.component]) {
    console.warn("Page Layout Component \"".concat(layout.component, "\" referenced by Page \"").concat(entity.name, "\" is not available in the provided set of templates (").concat(keys(pageLayouts).join(", "), "). Using default layout instead."));
  }
  var slicesRendered = useSlices && React.createElement(SlicesRenderer, {
    items: slices
  });
  var pagePathId = entity && (kebabCase(entity.path) || 'home');
  return React.createElement(My.Body, {
    className: "page-".concat(pagePathId, " ").concat(cls.name(className))
  }, React.createElement(Layout, {
    slices: slicesRendered,
    entity: entity
  }));
};
PageRenderer.defaultProps = PageRendererDefaultProps;
PageRenderer.cls = cls;
var templateObject_1, templateObject_2;